/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Folder Opened Icon component.
 */
export const SystemFolderOpenedIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M3.99609 17.9375V6.6875C3.99609 6.52174 4.06194 6.36277 4.17915 6.24556C4.29636 6.12835 4.45533 6.0625 4.62109 6.0625H8.78776C8.92299 6.0625 9.05458 6.10636 9.16276 6.1875L11.3294 7.8125C11.4376 7.89364 11.5692 7.9375 11.7044 7.9375H17.1211C17.2869 7.9375 17.4458 8.00335 17.563 8.12056C17.6802 8.23777 17.7461 8.39674 17.7461 8.5625V10.4375' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M3.99609 17.9375L6.35364 10.8649C6.39512 10.7404 6.47471 10.6322 6.58112 10.5555C6.68754 10.4788 6.81539 10.4375 6.94657 10.4375H19.379C19.478 10.4375 19.5756 10.461 19.6638 10.5062C19.7519 10.5513 19.8281 10.6167 19.886 10.6971C19.9439 10.7774 19.9819 10.8703 19.9968 10.9682C20.0117 11.0661 20.0032 11.1662 19.9719 11.2601L17.7461 17.9375H3.99609Z' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default SystemFolderOpenedIcon;
